/**
 * Modal.js
 * Created by calhosh on 6/5/2020.
 */
import React from 'react';
import PropTypes from 'prop-types';
import MotifModal from '@ey/canvascoreservices/Modal';

function Modal(props) {
	const {
		className = 'defaultModal',
		show,
		onHide,
		onOkClick,
		onSaveAndCreateNew,
		footerLabel = '',
		title,
		children,
		isOkButtonDisabled,
		isCancelButtonDisabled,
		showButtons,
		hideConfirmButton,
		hideCancelButton,
		showSaveAndCreateNewButton,
		confirmBtnTitle,
		closeBtnTitle,
		closeTitle,
		modalsize,
		modalbodystyle,
		modalContainerClass,
		modalonmodal,
		disableClose,
		okTitle,
		footerInfo,
		showCloseButton = true,
		isSaveAndCreateNewButtonDisabled,
		saveAndCreateNewBtnTitle,
		showToolTipButton = false,
		tooltipLabel,
		takeover,
		showFooter,
		customFooter,
		focusTrapPaused,
		labels,
		clearErrorOnClose = true,
		hideCloseButton = false,
		dynamicHeight = false,
		headerChildren,
		hideConfirmAndCloseButton,
		isCancelAndCloseButtonDisabled,
		confirmAndcloseBtnTitle,
		onConfirmAndCloseClick
	} = props;

	const handleOnClose = () => {
		onHide && onHide();
	};

	const useConfirmAndClose = !onOkClick && Boolean(onConfirmAndCloseClick);

	const handleOnOkClick = () => {
		if (useConfirmAndClose) {
			onConfirmAndCloseClick();
			return;
		}
		onOkClick && onOkClick();
	};

	return (
		<MotifModal
			show={show}
			onOkClick={handleOnOkClick}
			onSaveAndCreateClick={onSaveAndCreateNew}
			footerLabel={footerLabel}
			title={title}
			isOkDisabled={useConfirmAndClose ? isCancelAndCloseButtonDisabled : isOkButtonDisabled}
			isCancelDisabled={isCancelButtonDisabled}
			showButtons={showButtons}
			hideConfirmButton={useConfirmAndClose ? hideConfirmAndCloseButton : hideConfirmButton}
			hideCancelButton={hideCancelButton}
			hideMiddleButton={!showSaveAndCreateNewButton}
			middleButtonTitle={saveAndCreateNewBtnTitle}
			onMiddleButtonClick={onSaveAndCreateNew}
			confirmBtnTitle={useConfirmAndClose ? confirmAndcloseBtnTitle : confirmBtnTitle}
			closeBtnTitle={closeBtnTitle}
			closeTitle={closeTitle}
			modalsize={modalsize}
			focusTrapPaused={focusTrapPaused}
			modalbodystyle={modalbodystyle}
			modalContainerClass={modalContainerClass}
			disableClose={disableClose}
			okButtonTooltipOverride={okTitle}
			footerInfo={footerInfo}
			showCloseButton={showCloseButton}
			isMiddleButtonDisabled={isSaveAndCreateNewButtonDisabled}
			saveAndCreateNewBtnTitle={saveAndCreateNewBtnTitle}
			showToolTipButton={showToolTipButton}
			tooltipLabel={tooltipLabel}
			footerError
			onClose={handleOnClose}
			className={`${className} ${modalsize} ${modalContainerClass}`}
			modalonmodal={modalonmodal}
			takeover={takeover}
			showFooter={showFooter}
			customFooter={customFooter}
			labels={labels}
			hideCloseButton={hideCloseButton}
			dynamicHeight={dynamicHeight}
			headerChildren={headerChildren}
		>
			{children}
		</MotifModal>
	);
}

export default Modal;

Modal.propTypes = {
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	modalsize: PropTypes.string,
	confirmBtnTitle: PropTypes.string,
	closeBtnTitle: PropTypes.string,
	modalbodystyle: PropTypes.string,
	modalContainerClass: PropTypes.string,
	showButtons: PropTypes.bool,
	hideCloseButton: PropTypes.bool,
	hideConfirmButton: PropTypes.bool,
	hideCancelButton: PropTypes.bool,
	isOkButtonDisabled: PropTypes.bool,
	isCancelButtonDisabled: PropTypes.bool,
	disabled: PropTypes.bool,
	show: PropTypes.bool,
	hideConfirmAndCloseButton: PropTypes.bool,
	isCancelAndCloseButtonDisabled: PropTypes.bool,
	confirmAndcloseBtnTitle: PropTypes.string
};
